import { useState, useEffect, useReducer } from "react";
import { PropTypes } from "prop-types";
import axios from "axios";
import { API_BASE_URL } from "../../config/api"; // Import the config

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_INIT":
      return {
        ...state,
        isLoading: true,
        error: ""
      };
    case "FETCH_SUCCESS":
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    case "FETCH_FAILURE":
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      throw new Error(
        "ERROR: in useFetch: dunno what to do with this condition"
      );
  }
};

const useFetch = (initialUrl, initialData) => {
  const [url, setUrl] = useState(initialUrl);
  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoading: false,
    error: "",
    data: initialData
  });

  useEffect(() => {
    if (!url) return; // Don't fetch if no URL

    let didCancel = false;

    const fetchData = async () => {
      console.log("FETCHING DATA FROM:", url);
      console.log("API_BASE_URL:", API_BASE_URL);
      dispatch({ type: "FETCH_INIT" });

      try {
        const result = await axios(url);
        if (!didCancel) {
          console.log("result.data:", result.data);
          dispatch({ type: "FETCH_SUCCESS", payload: result.data });
        }
      } catch (e) {
        console.log("ERROR fetching data:", e.message);
        console.log("Failed URL:", url);
        if (!didCancel) {
          dispatch({ type: "FETCH_FAILURE", payload: e.message });
        }
      }
    };

    fetchData();

    return () => {
      didCancel = true;
    };
  }, [url]);

  const doFetch = url => {
    setUrl(url);
  };

  return [state, doFetch];
};

useFetch.propTypes = {
  initialUrl: PropTypes.string,
  initialData: PropTypes.any
};

export default useFetch;